import {
  CategoryFacet,
  CategoryFacetValue,
  DateFacet,
  LocationFacet,
  NumericFacet,
  RegularFacet,
  RegularFacetValue,
} from '@coveo/headless/commerce';

export interface NewSearchFacetButtonViewModel {
  facetDisplayMessage: string;
  facet:
    | RegularFacet
    | CategoryFacet
    | NumericFacet
    | LocationFacet
    | DateFacet;
}

export interface ToggleFacetEvent {
  facet: RegularFacet | CategoryFacet;
  value: RegularFacetValue | CategoryFacetValue;
}

export enum FacetViewOperation {
  viewMore,
  viewLess,
}

export interface FacetViewEvent {
  facet: RegularFacet | CategoryFacet;
  operation: FacetViewOperation;
}
